import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";

const Privacy = () => {
  const { t, lang } = useLanguage();
  const isAr = lang === "ar";

  return (
    <main data-testid="privacy-page" className="mx-auto max-w-4xl px-6 pb-24 pt-36 lg:px-10 lg:pt-44">
      <Reveal>
        <h1 className="font-display text-4xl font-extrabold md:text-5xl">
          {isAr ? "سياسة الخصوصية" : "Privacy Policy"}
        </h1>
        <p className="mt-4 text-sm text-zinc-500">{isAr ? "آخر تحديث: ٨ أغسطس ٢٠٢٦" : "Last updated: August 8, 2026"}</p>
      </Reveal>

      <div className="mt-10 flex flex-col gap-8 text-sm leading-relaxed text-zinc-400 md:text-base">
        <section>
          <h2 className="font-display text-xl font-bold text-white md:text-2xl">
            {isAr ? "١. البيانات التي نجمعها" : "1. What We Collect"}
          </h2>
          <p className="mt-3">
            {isAr
              ? "نحن لا نجمع أي بيانات شخصية من مكالماتك أو عملائك. يتم استخدام بيانات المكالمات فقط لأغراض تقارير الأداء ولا يتم مشاركتها أبداً مع أطراف ثالثة."
              : "We do not collect any personal data from your calls or clients. Call data is used solely for performance reporting and is never shared with third parties."}
          </p>
        </section>

        <section>
          <h2 className="font-display text-xl font-bold text-white md:text-2xl">
            {isAr ? "٢. تسجيل المكالمات" : "2. Call Recording"}
          </h2>
          <p className="mt-3">
            {isAr
              ? "جميع المكالمات مسجلة لأغراض الجودة والامتثال. يتم الاحتفاظ بالتسجيلات الصوتية لمدة 30 يوماً ثم يتم حذفها نهائياً."
              : "All calls are recorded for quality and compliance purposes. Voice recordings are retained for 30 days and then permanently deleted."}
          </p>
        </section>

        <section>
          <h2 className="font-display text-xl font-bold text-white md:text-2xl">
            {isAr ? "٣. مشاركة البيانات" : "3. Data Sharing"}
          </h2>
          <p className="mt-3">
            {isAr
              ? "لا نشارك بياناتك مع أي طرف ثالث. يتم استخدام بياناتك فقط لتشغيل خدمة صوتلي وتحسينها."
              : "We do not share your data with any third parties. Your data is only used to operate and improve Sawtly."}
          </p>
        </section>

        <section>
          <h2 className="font-display text-xl font-bold text-white md:text-2xl">
            {isAr ? "٤. حقوقك" : "4. Your Rights"}
          </h2>
          <p className="mt-3">
            {isAr
              ? "لديك الحق في طلب حذف بياناتك في أي وقت. تواصل معنا على contact@sawtly.net"
              : "You have the right to request deletion of your data at any time. Contact us at contact@sawtly.net"}
          </p>
        </section>

        <section>
          <h2 className="font-display text-xl font-bold text-white md:text-2xl">
            {isAr ? "٥. اتصل بنا" : "5. Contact Us"}
          </h2>
          <p className="mt-3">
            {isAr
              ? "لأي استفسار حول سياسة الخصوصية، راسلنا على: contact@sawtly.net"
              : "For any privacy questions, email us at: contact@sawtly.net"}
          </p>
        </section>
      </div>
    </main>
  );
};

export default Privacy;
